import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { setConfigurationLoginModalOpen } from '../../../store/actions'
import { Carousel } from '../../cdl-react-components/components'
import { sortPropFn } from '../../cdl-react-components/utilities'
import { WEBHOST_URL } from '../../cdl-react-components/utilities/constants'
import { trimFileLink } from '../../cdl-react-components/utilities/files'
import Link from '../Link'

class Thumbnails extends Component {
    state = { 
        parsedArtilceId: undefined,
        thumbnails: undefined 
    }

    parseThumbnails = (article) => {
        if (article) {
            let thumbnails = undefined

            if (article.thumbnails) {
                const splitThumbnails = article.thumbnails.split(',')
                const thumbnailObjs = splitThumbnails.map(uri => ({
                    pageNumber: parseInt(uri.match(/_[(\d)]+.png/)[0].replace('_', '').replace('.png','')) + 1,
                    uri
                }))
                thumbnails = thumbnailObjs.sort(sortPropFn('pageNumber'))
            }
        
            this.setState({ parsedArtilceId: article.id, thumbnails })
        }
    }

    renderItem = (article) => (item, i) => {
        return this.props.authenticated ?
            (<Link 
                key={'thumbnails--' + i}
                title={'Open Page ' + item.pageNumber}
                href={{ pathname: '/pdf', search: `?id=${article.id}&url=${'/' + trimFileLink(article.pdf)}&page=${item.pageNumber}` }} 
                draggable="false">
                <img src={`${WEBHOST_URL}/public/CDD/thumbnails/${article.id}/${item.uri}`} alt={'thumbnails--' + i} draggable="false" />
            </Link>) :
            (<img 
                key={'thumbnails--' + i}
                onClick={() => this.props.setConfigurationLoginModalOpen(true)}
                src={`${WEBHOST_URL}/public/CDD/thumbnails/${article.id}/${item.uri}`} alt={'thumbnails--' + i} draggable="false" />)
    }

    render() {
        const { article } = this.props
        const { thumbnails } = this.state
        
        return article && thumbnails ? (
            <Carousel 
                className="thumbnails"
                items={thumbnails}
                render={this.renderItem(article)} />
        ) : null
    }

    componentDidMount () {
        const { article } = this.props
        this.parseThumbnails(article)
    }

    componentDidUpdate() {
        const { article } = this.props
        if (article.id !== this.state.parsedArtilceId)
            this.parseThumbnails(article)
    }
}

Thumbnails.propTypes = {
    article: PropTypes.object.isRequired
}

const mapStateToProps = ({ data }) => ({ authenticated: data.authenticated })
const mapDispatchToProps = (dispatch) => ({ setConfigurationLoginModalOpen: (open) => dispatch(setConfigurationLoginModalOpen(open)) })

export default connect(mapStateToProps, mapDispatchToProps)(Thumbnails)